export default "__VITE_PUBLIC_ASSET__3a1a4235__"